import {
    INIT_WORKSPACE_INFO,
} from '../actions/actions';

const initial_info = {
    id: "",
    name: "",
    createdDate: "",
    updatedDate: "",

    // workspace 내 나의 member 정보
    member: {
        userId: "",
        workspaceId: "",

        id: "",
        name: "",
        email: "",
        phone: "",
        role: "",
        state: "",

        createdDate: "",
        updatedDate: "",
    },
};


export default function workspaceReducer(state = initial_info, action) {
    if (action.type === INIT_WORKSPACE_INFO) {
        return action.data
    }

    return state;
}